import * as React from "react";
import { IcoStift } from "./vg3Icons";
import "./vorgangV3.css";

/**
 * Die Zusammenfassung eines erledigten Vorgangs, dort wo man zuerst hinsieht
 * (PO 09.09.2026: „die Zusammenfassung über Notizen bei Vorgang ohne To-do, und
 * bei Vorgang mit To-do vor dem ersten").
 *
 * Sie steht damit VOR der Arbeit, nicht dahinter: Wer eine abgeschlossene Akte
 * öffnet, will zuerst wissen, was herauskam — nicht sich durch Notizen und
 * Verlauf lesen, um es sich zusammenzureimen. Wo genau sie hängt, entscheidet
 * der Aufrufer; das ist die einzige Stelle, an der sich beide Ausprägungen
 * (mit und ohne To-dos) unterscheiden.
 *
 * Ohne Text erscheint sie gar nicht. Ein leerer Kasten „noch keine
 * Zusammenfassung" wäre eine Aufgabe, die niemand gestellt hat — der Dialog
 * beim Abschließen darf übersprungen werden.
 */
export const ZusammenfassungKarte: React.FC<{
    text: string | null | undefined;
    canEdit: boolean;
    onAendern: () => void;
}> = ({ text, canEdit, onAendern }) => {
    const inhalt = (text ?? "").trim();
    if (!inhalt) return null;

    return (
        <section className="vg3-zus" aria-label="Zusammenfassung des Vorgangs">
            <div className="vg3-zus-kopf">
                <span className="vg3-abschnitt-h">Zusammenfassung</span>
                {canEdit && (
                    <button
                        type="button"
                        className="vg3-ibtn"
                        title="Zusammenfassung ändern"
                        aria-label="Zusammenfassung ändern"
                        onClick={onAendern}
                    >
                        <IcoStift size={15} />
                    </button>
                )}
            </div>
            {/* Zeilenumbrüche kommen aus einem Textfeld und sind Absicht —
                `white-space: pre-wrap` im CSS hält sie. */}
            <div className="vg3-zus-text">{inhalt}</div>
        </section>
    );
};
